import React from 'react';
import ZsFormikTextField from "src/components/atoms/zsTextField";
import * as Yup from "yup";
import {validate} from "src/utils/yup";

export interface IElectricityMeterProps {
}

export function ElectricityMeter(props: IElectricityMeterProps) {

    return (
        <>

            <label><span
                style={{color: '#F00'}}>*</span> Zähl<span className="spanHidden">autocompleteOff</span>erstand St<span className="spanHidden">autocompleteOff</span>rom</label>
            <ZsFormikTextField name="elecMeter"
                               type="onlyNumbers"
                               autoFocus
                               inputProps={{
                                   maxLength: 6,
                                   step: "1",
                                   min: 1
                               }}
                               validate={validate(Yup.number().typeError('Bitte den Zählerstand angeben.')
                                   .required("Bitte den Zählerstand für Strom angeben.")
                                   .max(999999, "Der Zählerstand darf maximal aus 6 Ziffern bestehen.")
                                   .min(1, "Der Zählerstand muss mindestens 1 sein."))}
                               required/>
        </>
    );

}